'use client'

import { ProductContent } from '@/components/content-types/product/product-content'

const Skeleton = (ProductContent as any).Skeleton

export default function ProductLoading() {
  return <Skeleton />
}
